import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCheck = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.1402 4.73477C21.7017 5.2963 21.7017 6.20821 21.1402 6.76973L9.64019 18.2697C9.07866 18.8313 8.16675 18.8313 7.60522 18.2697L1.85522 12.5197C1.2937 11.9582 1.2937 11.0463 1.85522 10.4848C2.41675 9.92325 3.32866 9.92325 3.89019 10.4848L8.62495 15.215L19.1097 4.73477C19.6712 4.17325 20.5832 4.17325 21.1447 4.73477H21.1402Z" fill={color} />
        </svg>
    </div>
);

export default IconCheck;